import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import * as actionTemplateActions from "../../../actions/actionTemplateActions";
import ActionReviewHook from "./ActionReviewHook";
import ActionEditorHook from "./ActionEditorHook";
import {createEditorOrigin, EDITOR_TYPES} from "../../../utilities/editorInstanceOwnership";

function ActionContainer(props) {
    const [template, setTemplate] = useState({});
    const [resolved, setResolved] = useState(false);
    const [templateKey, setTemplateKey] = useState("");
    
    const dispatch = useDispatch();
    const actionTemplate = useSelector(state => state.actionTemplate);
    const editorInstanceId = useSelector(state => state.actionEditor.instanceId);
    
    // Equivalent to componentDidMount
    useEffect(() => {
        let key = "";
        if (!props.templateKey) {
            key = props.match.params.templateKey;
        } else {
            key = props.templateKey;
        }
        setTemplateKey(key);
        dispatch(actionTemplateActions.getActionTemplate(key));
    }, [dispatch, props.templateKey, props.match?.params?.templateKey]);

    // Equivalent to componentWillReceiveProps
    useEffect(() => {
        if (templateKey !== "") {
            setTemplate(actionTemplate[templateKey]);
            setResolved(true);
        }
    }, [actionTemplate, templateKey]);

    const save = (saveObject) => {
        const requestOwner = createEditorOrigin(EDITOR_TYPES.ACTION, editorInstanceId);
        return dispatch(actionTemplateActions.saveActionTemplateAndCloseDrawer(
            saveObject,
            undefined,
            undefined,
            undefined,
            requestOwner
        ));
    };

    const getActionPreview = () => {
        if (resolved) {
            return (
                <div style={{ paddingTop: "20px" }}>
                    <Card>
                        <CardHeader
                            title={"Action: " + templateKey}
                            titleTypographyProps={{ color: "blue" }}
                            actAsExpander
                        >
                            <ActionReviewHook name={template.name} />
                        </CardHeader>
                        <CardContent expandable>
                            <ActionEditorHook save={save} width="90%" />
                        </CardContent>
                    </Card>
                </div>
            );
        } else {
            return <div />;
        }
    };

    return getActionPreview();
}

ActionContainer.propTypes = {
    templateKey: PropTypes.object,
    match: PropTypes.object
};

export default ActionContainer;